"use strict";

/**
 * Control zum Verwalten des Session basierten seitenübergreifenden Kartenausschnitt.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.GCSessionViewport = function( options )
{
    gc.gis.control.GCAbstractMapControl.call(this, options);
};
gc.gis.control.GCSessionViewport.prototype = Object.create( gc.gis.control.GCAbstractMapControl.prototype );

/**
 * @inheritdoc
 */
gc.gis.control.GCSessionViewport.prototype.init = function()
{
    this._map.on(gc.gis.map.GCMapEvent.VIEWPORT_CHANGEEND, this, function(evt) {
        if (evt.viewport)
        {
            gc.gis.GCStorage.setItem('session_viewport', JSON.stringify(evt.viewport),
                gc.gis.GCStorageType.SESSION_STORAGE);
        }
    });
};

/**
 * Liefert den aktuellen Viewport, der innerhalb der Session gespeichert ist oder <code>null</code>, falls keine
 * Viewport verfügbar ist.
 *
 * @param {string} [opt_target_projection] Zielprojektion, die beim Laden des Viewports hergestellt werden soll
 * @return {gc.gis.map.GCMapViewport|null}
 */
gc.gis.control.GCSessionViewport.prototype.getSessionViewport = function(opt_target_projection)
{
    var json = gc.gis.GCStorage.getItem('session_viewport', gc.gis.GCStorageType.SESSION_STORAGE);
    var viewport = null;

    if (json !== undefined && json !== null)
    {
        viewport = JSON.parse(json);

        if (viewport && viewport.projection && opt_target_projection
            && viewport.projection.toLowerCase() !== opt_target_projection.toLowerCase())
        {
            var format = gc.gis.iface.mapFactory.createFormat();

            // Geometrie in Objekt umwandlen mit eigener Projection und Viewport-Projection überschreiben
            // Transformation erfolgt dann in gc.gis.map.GCAbstractMap.setViewport() bzw. gc.gis.map.GCAbstractMap.fit()
            viewport.geometry = format.readGeometry(viewport.geometry, gc.gis.format.WKT, viewport.projection);
            viewport.projection = opt_target_projection;
        }
    }

    return viewport;
};